import { Api } from '../axios-config';

export interface IRegisterUserDto {
  email: string;
  password: string;
  fullName: string;
}

export interface IUserInterface {
  id: number;
  email: string;
  cidadeId: number;
  nomeCompleto: string;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface IUserProcessing {
  userToken: string;
  quantity: string; // BigInteger representado como string
  energy: string; // BigDecimal representado como string
  total: string;
  email: string;
  fullName: string;
  createdAt: string;
}

const getMe = async (): Promise<IUserInterface | Error> => {
  try {
    const { data } = await Api.get<IUserInterface>('/users/me');

    if (data) {
      return data;
    }

    return new Error('Erro ao obter os dados do usuário.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao obter os dados do usuário.');
  }
};

const getUserProcessing = async (): Promise<IUserProcessing | Error> => {
  try {
    const { data } = await Api.get<IUserProcessing>('/users/process');

    if (data) {
      return data;
    }

    return new Error('Erro ao obter o processamento do usuário.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao obter o processamento do usuário.');
  }
};

const register = async (registerUserDto: IRegisterUserDto): Promise<IUserInterface | Error> => {
  try {
    const { data } = await Api.post<IUserInterface>('/auth/signup', registerUserDto);

    if (data) {
      return data;
    }

    return new Error('Erro ao cadastrar o usuário.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao cadastrar o usuário.');
  }
};

export const UserService = {
  getMe,
  getUserProcessing,
  register,
};
